import { Schema as S } from "effect";

import { defineApi } from "../client";
import { Page } from "../schemas/common";
import { EventActivity, EventResponse } from "../schemas/events";

export const getEvents = defineApi("GetEvents", {
	args: { search: S.String, cursor: S.Number },
	response: Page(EventResponse),
	request: ({ search, cursor }) => ({
		method: "GET",
		path: "/events",
		query: { search, cursor },
	}),
});

/** Heatmap; `month` is `YYYY-MM`. */
export const getEventActivity = defineApi("GetEventActivity", {
	args: { month: S.String },
	response: EventActivity,
	request: ({ month }) => ({
		method: "GET",
		path: "/events/activity",
		query: { month },
	}),
});
